import React from "react"
import { FaExclamationTriangle } from "react-icons/fa"
import SiteContainer from "../../../../utils/SiteContainer"

const IncompleteData = () => (
  <SiteContainer>
    <div className="flex justify-center items-center my-8">
      <p
        className="mb-12 text-center border rounded-full p-2 px-6 text-sm
                   text-gray-100 bg-gray-700 flex items-center"
      >
        <span>
          <FaExclamationTriangle className="text-sm mr-2" />
        </span>
        <span>Please fill all inputs to get the results</span>
      </p>
    </div>
  </SiteContainer>
)

export default IncompleteData
